import SharedFunctions from '../shared_functions';
require('bootstrap/js/dist/modal');

$(document).ready(function () {

    let $email = $("#email");
    let $oilQuoteForm2 = $("#buy-now-quote-form-v4");
    let $oilQuoteFormToast2 = $(".toast");
    const min_litres = 150;
    const bt_min_litres = 150;

    // trigger the gdpr check on page load when email is pre populated
    SharedFunctions.form_display_gdpr_checkbox($email.val(), $("#opt_out_email"), $(".dont-send-me-checkbox"), $("#skip_opt_out_email"));

    // trigger the required tanker on page load when email is pre populated
    SharedFunctions.form_check_required_tanker_type($email.val(), $("#theTanker"));

    $oilQuoteForm2.submit(function () {
        let form_valid = true;
        let message = '';
        let error_message = '';
        let $email = $oilQuoteForm2.find("input#email");
        let email = $email.val();
        let $postcode = $oilQuoteForm2.find("input#postcode");
        let $litres = $oilQuoteForm2.find("input#volume");

        const $submitButton2 =  $(this).find("button[type='submit']");
        let buttonText2 = $submitButton2.text();
        $submitButton2.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading...');

        // Check if the button is already disabled
        if ($submitButton2.prop("disabled")) {
            e.preventDefault();
            return false; // Prevent further submission
        }

        // Disable the button to prevent double submission
        $submitButton2.prop("disabled", true);
        removeInvalidState($email, $postcode, $litres);

        //Validate email
        let email_check = SharedFunctions.form_email_valid(email, form_valid, message);
        form_valid = email_check[0]
        message = email_check[1]


        // strip excess whitespace from postcode val first
        $postcode.val($postcode.val().trim());

        // Validate the postcode field
        let postcode_check = SharedFunctions.form_postcode_valid($postcode, form_valid, message)
        form_valid = postcode_check[0]
        message = postcode_check[1]

        // check min litres by postcode
        if ($postcode.val().length > 0) {
            let min_litres_required = min_litres;
            let postcode_area = $postcode.val().substr(0, 2);

            if (postcode_area === 'BT') {
                min_litres_required = bt_min_litres;
            }
            if (parseInt($litres.val()) < min_litres_required) {
                form_valid = false;
                error_message = 'Please note the minimum order quantity is ' + min_litres_required + ' litres.';
                message += '<li>' + error_message + '</li>';

            }
        } else {
            form_valid = false;
            error_message = 'Please specify your required order volume.';
            message += '<li>' + error_message + '</li>';
        }

        if (!form_valid) {
            $oilQuoteFormToast2.append('<div class="toast-header bg-danger text-white"><strong class="mr-auto">Error</strong><small class="text-white">Just now</small><button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="toast-body bg-white"><ul>' + message + '</ul></div></div>');
            $oilQuoteFormToast2.toast('show');
            $oilQuoteFormToast2.on('hidden.bs.toast', function () {
                $oilQuoteFormToast2.html('');
            });

            // re-enable the submit button
            $submitButton2.prop("disabled", false);
        }

        if (form_valid && interstitial === "variant") {

            // show overlay
            window.showOverlay();

            // Submit after short delay
            setTimeout(() => {
              $oilQuoteForm2[0].submit(); // now submit the form
            }, 4800);

            return false;
        } else {

            return form_valid;
        }
    });

    function removeInvalidState(email, postcode, litres) {
        email.removeClass('is-invalid');
        postcode.removeClass('is-invalid');
        litres.removeClass('is-invalid');
    }

    $email.on("focusout", function () {
        let $containing_div = $(".dont-send-me-checkbox");
        let $checkbox = $("#opt_out_email");
        let $skipInput = $("#skip_opt_out_email");
        let email = $(this).val();

        SharedFunctions.form_display_gdpr_checkbox(email, $checkbox, $containing_div, $skipInput);
        SharedFunctions.form_check_required_tanker_type(email);
    });


});
